/* eslint-disable prettier/prettier */
import AccountingIcon from '../Icons/AccountingIcon';
import Ecommerce from '../Icons/Ecommerce';
import Integration from '../Icons/Integration';
import Logistics from '../Icons/Logistics';
import Document from '../Icons/Document';
import Blog from '../Icons/Blog';
import Todo from '../Icons/Todo';
import Website from '../Icons/Website';
import Sms from '../Icons/Sms';
import Corporate from '../Icons/Corporate';
import Crossbar_top from '../Icons/Crossbar_top';
import FleetIcon from '../Icons/FleetIcon';
import InvoiceIcon from '../Icons/InvoiceIcon';
import SoonIcon from '../Icons/SoonIcon';
import DynamicFormIcon from '../Icons/DynamicFormIcon';
import PayrollIcon from '../Icons/PayrollIcon';
import InventoryIcon from '../Icons/InventoryIcon';

export const ServicesList = [
  {
    image: AccountingIcon,
    title: 'Logistics',
    description: 'We provide seamless logistics solutions, including:',
    details: [
      {
        title: 'Transportation Management',
        description: 'for efficient and timely deliveries.',
      },
      {
        title: 'Storage Solutions',
        description: 'to ensure safe and organized inventory.',
      },
      {
        title: 'Inventory Mangaement',
        description: 'for real-time tracking and optimization.',
      },
      {
        title: 'Distributed Services',
        description: 'to streamline supply chain operations.',
      },
      {
        title: 'Route Optimization',
        description: 'to reduce costs and improve efficiency.',
      },
    ],
  },

  {
    image: Ecommerce,
    title: 'E-commerce',
    description: 'We provide end-to-end e-commerce solutions, including:',
    details: [
      {
        title: 'Online Selling',
        description: ' to help business reach global customers.',
      },
      {
        title: 'Inventory Management',
        description: 'for efficient stock control.',
      },
      {
        title: 'Secure Payment Processing',
        description: 'to ensure safe transactions.',
      },
      {
        title: 'Enhanced Shopping Experience',
        description: 'to drive business growth.',
      },
    ],
  },
  {
    image: Integration,
    title: 'API Integration',
    description: 'We offer API integration solutions, including:',
    details: [
      {
        title: 'Software Connectivity',
        description: ' to link different systems seamlessly.',
      },
      {
        title: 'Task Automation',
        description: 'to improve efficiency and reduce manual work.',
      },
      {
        title: 'Enhanced User Experience',
        description: 'through smooth system interactions.',
      },
      {
        title: 'Seamless Communication',
        description: 'between applications for better workflow.',
      },
    ],
  },
  {
    image: Logistics,
    title: 'Accounting',
    description: 'We provide comprehensive accounting solutions, including:',
    details: [
      {
        title: 'Financial Tracking',
        description: 'to monitor all transactions accurately.',
      },
      { title: 'Expense Management', description: 'for better cost control.' },
      {
        title: 'Profit Analysis',
        description: 'to evaluate business performance.',
      },
      {
        title: 'Tax Compliance',
        description: 'to ensure adherence to regulations.',
      },
      {
        title: 'Record Maintenance',
        description: 'for organized financial data.',
      },
      {
        title: 'Report generation',
        description: 'to provide valuable insights.',
      },
      {
        title: 'Business Decision Support',
        description: 'through data-driven analysis.',
      },
    ],
  },

  {
    image: Document,
    title: 'Document Management',
    description: 'We offer document management solutions, including:',
    details: [
      {
        title: 'File Organization',
        description: 'to arrange documents efficiently.',
      },
      { title: 'Secure Storage', description: 'to protect important files.' },
      {
        title: 'Quick Retrieval',
        description: 'for easy access to information.',
      },
      {
        title: 'paper Reduction',
        description: 'to minimize unnecessary paper usage.',
      },
      { title: 'Improved Collaboration', description: 'to enhance teamwork.' },
      {
        title: 'Seamless Access',
        description: 'for uninterrupted information availability.',
      },
    ],
  },

  {
    image: Blog,
    title: 'Blog',
    description: 'We provide a powerful blog platform, including:',
    details: [
      {
        title: 'Content Publishing',
        description: 'to share articles,stories,and insights.',
      },
      { title: 'Reader Engagement', description: 'to connect with audiences.' },
      {
        title: 'Discussion Forums',
        description: 'to foster meaningful conversations.',
      },
      {
        title: 'Customizable Features',
        description: 'to match individual or business needs.',
      },
      {
        title: 'SEO Optimization',
        description: 'to improve visibility and reach.',
      },
    ],
  },

  {
    image: Todo,
    title: 'To Do',
    description: 'We offer a smart To-Do list solution, including:',
    details: [
      {
        title: 'Task Organization',
        description: 'to keep everything structured.',
      },
      { title: 'Goal Setting', description: 'to track progress effectively.' },
      {
        title: 'Priority Management',
        description: 'to focus on important activities.',
      },
      { title: 'Productivity Enhancement', description: 'to stay efficient' },
      {
        title: 'Flexible Planning',
        description: 'for daily,weekly, or long-term tasks.',
      },
    ],
  },

  {
    image: Website,
    title: 'Website Builder',
    description: 'We provide an intuitive website builder, including:',
    details: [
      {
        title: 'Pre-Designed Templates',
        description: 'for quick website creation.',
      },
      {
        title: 'Drag-and-Drop Features',
        description: 'for easy customization.',
      },
      {
        title: 'No Coding Required',
        description: 'to build website effortlessly.',
      },
      {
        title: 'Full Customization',
        description: 'to match your brand identity.',
      },
      {
        title: 'User-Friendly Interface',
        description: 'for a seamless experience',
      },
    ],
  },

  {
    image: Sms,
    title: 'SMS/Email Marketing',
    description: 'We offer SMS/email marketing solutions, including:',
    details: [
      {
        title: 'Targeted Messaging',
        description: 'to reach the right audience.',
      },
      {
        title: 'Product Promotion',
        description: 'to boost visibility and sales.',
      },
      {
        title: 'Relationship Building',
        description: 'to enhance customer connections.',
      },
      {
        title: 'Increased Engagement',
        description: 'through interactive contnet.',
      },
      {
        title: 'Sales Growth',
        description: 'with strategic marketing campaigns.',
      },
      {
        title: 'Customer Retention',
        description: 'using personalized communication.',
      },
    ],
  },

  {
    image: Corporate,
    title: 'Corporate EMail',
    description: 'We provide secure corporate email solutions, including:',
    details: [
      {
        title: 'Professional Communication',
        description: 'for a credible brand image.',
      },
      {
        title: 'Enhanced Collaboration',
        description: 'through seamless email integration.',
      },
      {
        title: 'Organized Messaging',
        description: 'to streamline intermal workflows.',
      },
      {
        title: 'Increased Credibility',
        description: 'with custom domain emails.',
      },
      {
        title: 'Maximum Efficiency',
        description: 'in managing corporate correspondence.',
      },
    ],
  },
];

export const NewServiceList = [
  {
    image: FleetIcon,
    images: SoonIcon,
    title: 'Fleet',
    description: 'This feature will be launched soon.Stay tuned for updates!',
  },

  {
    image: InvoiceIcon,
    images: SoonIcon,
    title: 'Invoicing',
    description: 'This feature will be launched soon.Stay tuned for updates!',
  },

  {
    image: InventoryIcon,
    images: SoonIcon,
    title: 'Inventory',
    description: 'This feature will be launched soon.Stay tuned for updates!',
  },
  {
    image: DynamicFormIcon,
    images: SoonIcon,
    title: 'Dynamic Form',
    description: 'This feature will be launched soon.Stay tuned for updates!',
  },
  {
    image: PayrollIcon,
    images: SoonIcon,
    title: 'Payroll',
    description: 'This feature will be launched soon.Stay tuned for updates!',
  },
];

export const Crossbar = {
  image: Crossbar_top,
  title: 'Are you sure you want to close it ?',
};
